import * as TabsPrimitive from '@radix-ui/react-tabs'
import { cx } from '../util/cx'
import styles from './Tabs.module.css'

export interface TabItem<T extends string> {
  value: T
  label: React.ReactNode
}

interface TabsProps<T extends string> {
  value: T
  onChange: (value: T) => void
  items: TabItem<T>[]
  variant?: 'segment' | 'pill' | 'underline'
  className?: string
  listClassName?: string
  ariaLabel?: string
}

export default function Tabs<T extends string>({
  value,
  onChange,
  items,
  variant = 'segment',
  className,
  listClassName,
  ariaLabel = 'Tabs',
}: TabsProps<T>) {
  return (
    <TabsPrimitive.Root value={value} onValueChange={(next) => onChange(next as T)}>
      <TabsPrimitive.List
        className={cx(styles.list, styles[variant], listClassName, className)}
        aria-label={ariaLabel}
      >
        {items.map((item) => (
          <TabsPrimitive.Trigger
            key={item.value}
            value={item.value}
            className={cx(styles.trigger, styles[`${variant}Trigger`])}
          >
            {item.label}
          </TabsPrimitive.Trigger>
        ))}
      </TabsPrimitive.List>
    </TabsPrimitive.Root>
  )
}
